import phoneEncrypt from "./maskPhone" /* 隐藏 phone 中间数字 */
import amountFormat from "./amountFormat" /* 格式化金额 */
import videoWater from "./videoWater" /* 水印 */
import clipboard from "./clipboard" /* copy 文字 */
import btnCountDown from "./btnCountDown" /* 按钮倒计时 */

export default {
  install(app) { /* 批量注册 */
    app.directive('phone-encrypt', phoneEncrypt) /* 隐藏 phone 中间数字 */
    app.directive('amount-format', amountFormat) /* 格式化金额 */
    app.directive('video-water', videoWater) /* 水印 */
    app.directive('clipboard', clipboard) /* copy 文字 */
    app.directive('btn-count-down', btnCountDown) /* 按钮倒计时 */
  }
}